import { PageWrapper, PublicFooter } from "shared/components";
import { Maintenance } from "../components";

const MaintenancePage = () => {
  return (
    <PageWrapper>
      <Maintenance />
      <PublicFooter />
    </PageWrapper>
  );
};

export default MaintenancePage;
